import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { verifyPaymentLink } from '../api/paymentAPI';  
import SuccessImage from "../../assets/images/undraw_confirmed_c5lo.svg"; 


const PaymentCallback = () => {
  const [status, setStatus]       = useState("Verifying payment...");
  const [isSuccess, setIsSuccess] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const linkId = query.get("razorpay_payment_link_id");
    const paymentStatus = query.get("razorpay_payment_link_status");


    if (!linkId) {
      setStatus("Invalid or missing payment link.");
      return;
    }

    const verifyPayment = async () => {

      try {
        const response = await verifyPaymentLink({ linkId });      
        if (response.success === true && paymentStatus == "paid") {
          setStatus("Payment successful! Your booking is confirmed.");
          setIsSuccess(true);
        } else {
          setStatus("Payment failed or expired. Please try again.");
        }    
      } catch (err) {
        // console.error(err);
        setStatus("Error verifying payment, Please reload the page.");
      }
    };

    verifyPayment();
}, [location.search]);

  return (
    <div style={{ padding: "2rem", textAlign: "center", marginTop:'15rem' }}>
   
        {isSuccess && (
        <img
          src={SuccessImage}
          alt="Payment Successful"
          style={{
            width: "100%",
            maxWidth: "200px",
            height: "auto",
            marginTop: "2rem"
          }}

        />
      )}
         <h2 style={{fontSize:'3rem'}}>{status}</h2>
    </div>
  );
};

export default PaymentCallback;
